import { ReactNode, useContext } from "react";
import { Navigate, useLocation } from "react-router";
import { AppCtx } from "../../provider/AppContext";

interface ProtectedRouteProps {
    children: ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
    const appContex = useContext(AppCtx);
    const location = useLocation();

    // Si tiene traccia della rotta di partenza: dopo il login si torna dove si era,
    // invece di finire sempre sulla home.
    if (!appContex.isLogged)
        return <Navigate to="/auth/login" replace state={{ from: location }} />;

    return <>{children}</>;
}

export default ProtectedRoute;
